import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpportunityService {
  private readonly http = inject(HttpClient);

  create(data) {
    return this.http.post(
      `${environment.baseUrl}/salesforce/opportunity`,
      data
    );
  }

  getList(listName: string, filterKey?: string) {
    return this.http
      .get<any>(`${environment.baseUrl}/salesforce/dynamic-field/${listName}`)
      .pipe(
        map((res) => {
          if (filterKey) {
            const filterValue = Object.values(res.controllerValues).find(
              (v) => v === res.controllerValues[filterKey]
            );
            return res.values.filter((item) =>
              item.validFor.includes(filterValue)
            );
          } else {
            return res.values;
          }
        })
      );
  }
}
